import { FC, useState } from 'react';
import {useTranslation} from 'react-i18next';

import { translateError } from '~src/services/translationServices';

import { ErrorMessage, InputWithLabel } from './inputs.sc';

export type TextAlign = 'left' | 'right';

interface Props {
  valid: boolean;
  hasValue: boolean;
  insideForm: boolean;
  error?: string;
  label: string;
  labelKey: string;
  isTextArea?: boolean;
  readonly?: boolean;
  textAlign?: TextAlign;
  errorParams?: Record<string, string>;
  children: ReactNode;
}

const InputLabelWrapper: FC<Props> = ({
  valid,
  insideForm,
  hasValue,
  children,
  labelKey,
  isTextArea,
  label,
  error,
  textAlign = 'left',
  errorParams,
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const clickInput = () => {
    setIsFocused(true);
  };

  const { t } = useTranslation();

  const blurInput = () => {
    setIsFocused(false);
  };

  return (
    <InputWithLabel
      $valid={valid}
      $hasValue={isFocused || hasValue}
      onFocus={clickInput}
      onBlur={blurInput}
      $insideForm={insideForm}
      $isTextArea={isTextArea}
      $textAlign={textAlign}
    >
      {children}
      <label data-translation={labelKey} style={{ pointerEvents: 'none' }}>
        {label}
      </label>
      {error && <ErrorMessage className={error ? 'visible' : ''}>{translateError(t, error, { field: label, ...errorParams })}</ErrorMessage>}
    </InputWithLabel>
  );
};

export default InputLabelWrapper;
